import { ORDERED_LIST_KEY, UNORDERED_LIST_KEY } from '@techchange/pm-specs';

/**
 * Determines whether a selection contains mixed list types.
 *
 * @param {number} from   The start index of the selection
 * @param {number} to     The end index of the selection
 * @param {Object} state  The document state
 *
 * @returns {Array} The list types in the selection
 */
export const getSelectionListTypes = (from, to, state) => {

	const orderedListType = state.schema.nodes[ORDERED_LIST_KEY];
	const unorderedListType = state.schema.nodes[UNORDERED_LIST_KEY];

	const listTypes = new Set([]);

	state.doc.nodesBetween(from, to, (node, pos) => {

		if (node.type === orderedListType || node.type === unorderedListType) {

			// Check if the root paragraph node of any of the list items are selected
			node.descendants((child, childPos) => {

				const paragraphNode = child.firstChild;
				const paragraphPos = pos + 1 + childPos + 1;

				const isSelected = (paragraphPos + paragraphNode.nodeSize) > from && paragraphPos <= to;

				if (isSelected) {

					listTypes.add(node.type);

				}

				// Don't recurse to children nodes
				return false;

			});

		}

		return true;

	});

	return [...listTypes];

};
